import { UseMutationOptions, UseQueryOptions, useMutation, useQuery, useQueryClient } from "react-query";
import { NotificationType } from "@arelia-components/notifications/Notification";
import { http } from "./http";

export const NOTIFICATION_QUERY_KEY = `/api/notifications`;

export function useNotifications(ops?: UseQueryOptions<NotificationType[]>) {
  return useQuery<NotificationType[]>({
    queryKey: [NOTIFICATION_QUERY_KEY],
    queryFn: () => http(`/api/notifications`),
    ...ops
  });
}

export function useReadNotificationMutation() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (id?: string | void) => http(`/api/notifications/read/${id ?? "all"}`, {
      method: 'PUT',
    }),
    onSuccess: () => client.invalidateQueries(NOTIFICATION_QUERY_KEY)
  });
}

export function useDeleteNotificationMutation() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => http(`/api/notifications/broadcast/${id}`, {
      method: 'DELETE',
    }),
    onSuccess: () => client.invalidateQueries(NOTIFICATION_QUERY_KEY)
  });
}

export function useBroadcastNotificationMutation(ops?: UseMutationOptions<any, any, any, any>) {
  const client = useQueryClient();
  return useMutation({
    ...ops,
    mutationFn: (message: string) => http(`/api/notifications/broadcast`, {
      method: "POST",
      body: {
        message,
        source: "Arelia"
      }
    }),
    onSuccess: (data, vars, context) => {
      ops?.onSuccess?.(data, vars, context);
      client.invalidateQueries(NOTIFICATION_QUERY_KEY)
    }
  });
}

export function useEditNotificationMutation(ops?: UseMutationOptions<any, any, any, any>) {
  const client = useQueryClient();
  return useMutation({
    ...ops,
    mutationFn: (notification: NotificationType) => http(`/api/notifications/broadcast/${notification.key}`, {
      method: "POST",
      body: notification
    }),
    onSuccess: (data, vars, context) => {
      ops?.onSuccess?.(data, vars, context);
      client.invalidateQueries(NOTIFICATION_QUERY_KEY)
    }
  });
}